import React from 'react';

export class Content extends React.Component {
  render() {
    return <div className='content'>{this.props.children}</div>;
  }
}
